export const AD_TAG_LIST_FIELD = 'adTagList';

export const HANDLE_RESET_TITLE = 'Discard Changes';
export const SUBMIT_FORM_TITLE = 'Save Ad';

export const CREATE_AD_TITLE = 'Create Ad';
export const EDIT_AD_TITLE = 'Edit Ad';
